/**
 * `LifecycleSection` - status pills + lifecycle timestamps.
 *
 * Renders the four "where is the account right now?" facets:
 *   - `status` (SM2-projection status)
 *   - `account_status` (raw legacy column - opaque codes)
 *   - `external_banking_status` (raw legacy column - opaque codes)
 *   - timestamps: `legacy_created_at`, `legacy_updated_at`,
 *     `last_dormancy_assessed_at`, `first_load_at`, `deleted_at`.
 *
 * No PII in this section.
 */
import type { Account } from '../../../lib/bff-client'
import { StatusPill } from '../../../components/status-pill'
import { Field, FieldValue, Section, Timestamp } from './section'

export interface LifecycleSectionProps {
  readonly account: Account
}

export function LifecycleSection({ account }: LifecycleSectionProps): JSX.Element {
  return (
    <Section title="Lifecycle" columns={1}>
      <Field label="Status">
        <StatusPill status={account.status} />
      </Field>
      <Field label="Legacy account_status">
        <FieldValue value={account.account_status} />
      </Field>
      <Field label="External banking status">
        <FieldValue value={account.external_banking_status} />
      </Field>
      <Field label="Created (legacy)">
        <Timestamp value={account.legacy_created_at} />
      </Field>
      <Field label="Updated (legacy)">
        <Timestamp value={account.legacy_updated_at} />
      </Field>
      <Field label="Last dormancy assessed">
        <Timestamp value={account.last_dormancy_assessed_at} />
      </Field>
      <Field label="First load">
        <Timestamp value={account.first_load_at} />
      </Field>
      <Field label="Deleted at">
        <Timestamp value={account.deleted_at} />
      </Field>
    </Section>
  )
}
